export default __webpack_public_path__ + "static/01-04-reading-audio-narration-7f25aceb37399115279f18a63ab3d665.mp4";